"use strict";
/**
 * imports
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketConnection = void 0;
// external
const inversify_1 = require("inversify");
const io = require("socket.io-client");
/**
 * web socket connection class
 */
let WebSocketConnection = class WebSocketConnection {
    constructor() {
        // event scopes to listen on
        this.eventScopes = [];
    }
    /**
     * set socket connection url
     *
     * @param {string} url
     */
    setUrl(url) {
        // connect to url
        this.socket = io.connect(url, {
            transports: ["websocket"],
            upgrade: false
        });
        // resubscribe to event scopes on socket reconnect
        this.socket.on("reconnect", () => {
            this.resubscribe();
        });
    }
    /**
     * get session token
     *
     * @returns {string}
     */
    get sessionToken() {
        return this._sessionToken;
    }
    /**
     * set session token
     *
     * @param {string | null} newSessionToken
     */
    set sessionToken(newSessionToken) {
        // if the tokens are the same, do nothing
        if (newSessionToken === this._sessionToken) {
            return;
        }
        // set the session token to the new
        this._sessionToken = newSessionToken;
        // resubscribe
        this.resubscribe();
    }
    /**
     * resubscribe socket to event scopes
     */
    resubscribe() {
        // if no session is present then disconnect the socket
        if (this.sessionToken === null) {
            this.socket.emit("disconnect");
            return;
        }
        // let socket subscribe to event scopes
        this.socket.emit("subscribe", this.sessionToken, this.eventScopes);
    }
    /**
     * run function on scope and event
     *
     * @param {string} eventScope
     * @param {string} event
     * @param {(...args: any[]) => void} func
     */
    on(eventScope, event, func) {
        // ensure that this eventScope is registered
        if (this.eventScopes.indexOf(eventScope) === -1) {
            this.eventScopes.push(eventScope);
            this.resubscribe();
        }
        // listen to event scope and event to run function
        this.socket.on(`${eventScope}|${event}`, func);
    }
    /**
     * remove function to run on scope and event
     *
     * @param {string} eventScope
     * @param {string} event
     * @param {(...args: any[]) => void} func
     */
    off(eventScope, event, func) {
        this.socket.off(`${eventScope}|${event}`, func);
    }
    emit(event, ...args) {
        this.socket.emit(event, ...args);
    }
};
WebSocketConnection = __decorate([
    (0, inversify_1.injectable)()
], WebSocketConnection);
exports.WebSocketConnection = WebSocketConnection;
//# sourceMappingURL=WebSocketConnection.js.map